import React from 'react';
import styled, { injectGlobal } from 'styled-components';
import { Flex, Box } from 'grid-styled';

injectGlobal`
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700|Pacifico');
* {
    box-sizing: border-box;
  }
  &:after {
    content: '';
    clear: both;
    display: table;
  }
  html,body {
    width: 100%;
    height: 100%;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    background: white;
    margin: 0;
    padding: 0;
    color: #333;
  }
  a {
      text-decoration: none;
    }
  button { cursor: pointer;}
  ul {
      margin: 0;
      padding: 0;
      li {
        list-style: none;
      
      }
    }
`;

export const Row = props => <Flex flexWrap="wrap" {...props} />;

export const Column = props => <Box {...props} flex="1 1 auto" />;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-image: url(${props => props.bgURL});
  background-size: cover;
`;

export const Container = Box.extend`
  position: relative;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
`;

export const Button = styled.button`
  display: block;
  text-shadow: 0 1px 0 #fff;
  text-align: center;
  padding: 0.625em 1em;
  color: #333;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  background-image: linear-gradient(to bottom, #fff 0, #e0e0e0 100%);
  border-color: #ccc;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.075);
  float: ${props => (props.right ? 'right' : 'none')};
  cursor: pointer;
  &:hover {
    background-color: #e0e0e0;
    background-position: 0 0;
    color: #333;
    border-color: #adadad;
  }
`;

export const HeaderStyled = styled.header`
  position: fixed;
  width: 100%;
  margin: 0 auto 20px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  background-image: linear-gradient(to bottom, #3c3c3c 0, #222 100%);
  color: white;
`;

export const ErrorMessage = styled.h1`
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/ui/Styles.js